import React from "react";
import * as S from "./Button.styles";
import { ReactComponent as ArrowLeft } from "../../assets/icons/arrow-left-solid.svg";

export const Button = ({ decrement }) => {
  return (
    <S.Container>
      <ArrowLeft />
      <S.Button onClick={decrement}>Voltar</S.Button>
    </S.Container>
  );
};
